export default __webpack_public_path__ + "static/media/notScript.403effab.svg";